import {
	IAdapterContext,
	WebexCallHistoryAdapter,
	WebexCallSettingsAdapter,
	WebexVoicemailAdapter,
	WebexEventsAdapter
} from '../packages/widgets/src';
import {
	MsTeamsMakeCallAdapter
} from './MsTeamsMakeCallAdapter';
import {
	MsTeamsSearchContactsAdapter
} from './MsTeamsSearchContactsAdapter';
import {
	MsTeamsSpeedDialAdapter
} from './MsTeamsSpeedDialAdapter';


// Initialize adapter
export const MsTeamsSDKAdapter: IAdapterContext = {
	searchContactsAdapter: new MsTeamsSearchContactsAdapter(),
	callHistoryAdapter: new WebexCallHistoryAdapter(),
	makeCallAdapter: new MsTeamsMakeCallAdapter(),
	voicemailAdapter: new WebexVoicemailAdapter(),
	speedDialsAdapter: new MsTeamsSpeedDialAdapter(),
	callForwardAdapter: new WebexCallSettingsAdapter(),
	eventAdapter: new WebexEventsAdapter(),
	// DSS plugin for phone enrichment - returns real webex.internal.dss
	get dss() {
		const webex = (window as any).webex;
		const webexInternal = webex?.internal;
		const dss = webexInternal?.dss;
		if (dss && !(dss as any).parent && !(dss as any).collection) {
			(dss as any).parent = webex;
		}
		console.log('[Enrichment] Adapter: DSS getter called:', {
			hasWindow: typeof window !== 'undefined',
			hasWebex: Boolean(webex),
			isWebexInitialized: (window as any).isWebexInitalized,
			hasInternal: Boolean(webexInternal),
			hasDss: Boolean(dss),
			dssType: typeof dss,
			dssKeys: dss ? Object.keys(dss) : [],
			// Show what plugins ARE available in webex.internal
			availableInternalPlugins: webexInternal ? Object.keys(webexInternal).filter(k => typeof webexInternal[k] === 'object' && webexInternal[k] !== null).slice(0, 20) : []
		});
		return dss;
	}
};
